    //重定向下载地址
    // http://www.simrex.com.cn/download_zoomy.html
    // https://simrexstore.com/download_zoomy.html
    var get_href_url = location.href;
    var Old_website = 'http://www.simrex.com.cn/';
    var Old_website2 = 'https://simrexstore.com/';
    var New_website = 'https://buy.simrexstore.com';
    var Shopfiy_url = 'https://www.simrexstore.com/';
    var requestParams = '';
    var Old_url = '';

    if (get_href_url.indexOf('?') !== -1) {
      requestParams = get_href_url.substr(get_href_url.indexOf('?') + 1); //截取?后面的内容作为字符串
      let num = get_href_url.indexOf("?")
      Old_url = get_href_url.substring(0,num)
    }else{
      Old_url = get_href_url
    }
    console.log(requestParams);
    console.log(Old_url);

    //产品说明书上的二维码重定向下载地址
    if(Old_url ==  Old_website + 'download_zoomy.html' || Old_url ==  Old_website2 + 'download_zoomy.html'){
      //无人机下载地址
      // post_fun('download_zoomy.html')
      location.href = "https://s3-us-simrex-prod.simrexstore.com/app/download_zoomy.html"
    }else if(Old_url ==  Old_website + 'download_track.html' || Old_url ==  Old_website2 + 'download_track.html'){
      location.href = "https://s3-us-simrex-prod.simrexstore.com/app/download_track.html"
    }else if(Old_url ==  Old_website + 'download_app.html' || Old_url ==  Old_website2 + 'download_app.html'){
      location.href = "https://s3-us-simrex-prod.simrexstore.com/app/download_go.html"
    }else{
      console.log(Old_url, '无');
    }
    
    function post_fun(url){
      if(requestParams){
        location.href = New_website + url + '?' + requestParams
      }else{
        location.href = New_website + url
      }
    }

    // 为了处理旧官网的详情页地址重定向到新地址
    //截止网址后面的路由地址
    var pathname = window.location.pathname;
    if(pathname){
      console.log('pathname')
      console.log(pathname)
      //截止网址后面的第一个路由地址
      var router_first = pathname.split('/')[1];
      //截止网址后面的第二个路由地址
      var router_second = pathname.split('/')[2];

      let go_url = ''
      // 无用的旧页面重定向
      if(pathname == '/32-x800'){
        go_url = Shopfiy_url + 'pages/x800'
      }else if(pathname == '/33-x300c' || pathname == '/34-new-series'){
        go_url = Shopfiy_url + 'pages/x300c'
      }else if(pathname == '/23-x900'){
        go_url = Shopfiy_url + 'pages/x900'
      }else if(pathname == '/31-x700'){
        go_url = Shopfiy_url + 'pages/x700'
      }else if(router_first.includes("about")){
        go_url = Shopfiy_url + 'pages/x20-drone-support'
      }else if(router_first.includes("x11")){
        go_url = Shopfiy_url + 'pages/x11-drone-support'
      }else if(router_first.includes("x20")){
        go_url = Shopfiy_url + 'pages/x20-drone-support'
      }else if(router_first.includes("x500")){
        go_url = Shopfiy_url + 'pages/x500'
      }else if(router_first.includes("x700")){
        go_url = Shopfiy_url + 'pages/x700'
      }else if(router_first.includes("x900")){
        go_url = Shopfiy_url + 'pages/x900'
      }
      if(go_url){
        location.href = go_url
      }
    }
  